import { useCallback, useEffect, useState } from "react";

import { hintBadgeModeChangeEvent, readHintBadgeMode, writeHintBadgeMode } from "~/helpers/hintBadgeMode";

export interface UseHintBadgeModeReturn {
	enabled: boolean;
	setEnabled: (enabled: boolean) => void;
	toggle: () => void;
}

const persist = (enabled: boolean) => {
	writeHintBadgeMode({ enabled });
	window.dispatchEvent(new Event(hintBadgeModeChangeEvent));
};

const useHintBadgeMode = (): UseHintBadgeModeReturn => {
	const [enabled, setLocalEnabled] = useState(() => readHintBadgeMode().enabled);

	useEffect(() => {
		const sync = () => setLocalEnabled(readHintBadgeMode().enabled);
		window.addEventListener(hintBadgeModeChangeEvent, sync);
		window.addEventListener("storage", sync);
		return () => {
			window.removeEventListener(hintBadgeModeChangeEvent, sync);
			window.removeEventListener("storage", sync);
		};
	}, []);

	const setEnabled = useCallback((next: boolean) => persist(next), []);

	const toggle = useCallback(() => persist(!readHintBadgeMode().enabled), []);

	return { enabled, setEnabled, toggle };
};

export default useHintBadgeMode;
